import { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import Icon from '../shared/Icon';
import FeedbackModal from './FeedbackModal';

/**
 * MessageActions component - Displays action buttons for AI messages
 *
 * @param {Object} props - Component props
 * @param {Function} props.onCopyMessage - Callback for copying message
 * @param {Function} props.onPositiveFeedback - Callback for positive feedback
 * @param {Function} props.onNegativeFeedback - Callback for negative feedback (receives feedback details)
 * @returns {JSX.Element} MessageActions component
 */
const MessageActions = ({ onCopyMessage, onPositiveFeedback, onNegativeFeedback }) => {
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  const handleNegativeFeedbackClick = () => {
    setFeedbackModalOpen(true);
  };

  const handleFeedbackSubmit = (feedbackData) => {
    onNegativeFeedback(feedbackData);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Tooltip title="Copy Message" arrow placement="bottom" enterDelay={500}>
        <IconButton
          size="small"
          onClick={onCopyMessage}
          sx={{
            color: 'text.secondary',
            width: 'var(--chat-action-icon-size)',
            height: 'var(--chat-action-icon-size)',
            opacity: 'var(--chat-action-icon-opacity)',
            '&:hover': {
              color: 'primary.main',
              opacity: '1',
            },
          }}
        >
          <Icon name="copy" size={20} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Give Positive Feedback" arrow placement="bottom" enterDelay={500}>
        <IconButton
          size="small"
          onClick={onPositiveFeedback}
          sx={{
            color: 'text.secondary',
            width: 'var(--chat-action-icon-size)',
            height: 'var(--chat-action-icon-size)',
            opacity: 'var(--chat-action-icon-opacity)',
            '&:hover': {
              color: 'success.main',
              opacity: '1',
            },
          }}
        >
          <Icon name="thumb-up" size={20} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Give Negative Feedback" arrow placement="bottom" enterDelay={500}>
        <IconButton
          size="small"
          onClick={handleNegativeFeedbackClick}
          sx={{
            color: 'text.secondary',
            width: 'var(--chat-action-icon-size)',
            height: 'var(--chat-action-icon-size)',
            opacity: 'var(--chat-action-icon-opacity)',
            '&:hover': {
              color: 'error.main',
              opacity: '1',
            },
          }}
        >
          <Icon name="thumb-down" size={20} />
        </IconButton>
      </Tooltip>

      <FeedbackModal
        open={feedbackModalOpen}
        onClose={() => setFeedbackModalOpen(false)}
        onSubmit={handleFeedbackSubmit}
      />
    </Box>
  );
};

export default MessageActions;
